
import { getSpellIconPathByName } from '../../utils'
import './Selector.css'

export default function Selector({ name, displayName=null, src, onClick, isSelected=false, className, style, children }) {

    if (displayName == null) {
        displayName = name
    }

    return (
        <div className={`selector spoiler ${isSelected? 'selected': ''} ${className}`} onClick={onClick} style={style}>
            <div className="flex">
                <div className="icon-wrapper">
                    <div className='icon-border'>
                        <img src={src}/>
                    </div>
                </div>
                <div className="name-wrapper">{ displayName }</div>
            </div>
            <div>
                { children }
            </div>
        </div>
    )
}